/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free color converter. Convert between HEX, RGB and HSL, pick a color, and copy any format. Live preview, runs in your browser.`)
};

const es_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de colores gratuito. Convierte entre HEX, RGB e HSL, elige un color y copia cualquier formato. Vista previa en vivo, se ejecuta en tu navegador.`)
};

const de_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Farbkonverter. Konvertieren Sie zwischen HEX, RGB und HSL, wählen Sie eine Farbe aus und kopieren Sie jedes Format. Live-Vorschau, läuft in Ihrem Browser.`)
};

const nl_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis kleurconverter. Converteer tussen HEX, RGB en HSL, kies een kleur en kopieer elk formaat. Live voorbeeld, draait in uw browser.`)
};

const fr_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de couleurs gratuit. Convertissez entre HEX, RGB et HSL, choisissez une couleur et copiez n'importe quel format. Aperçu en direct, s'exécute dans votre navigateur.`)
};

const it_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di colori gratuito. Converti tra HEX, RGB e HSL, scegli un colore e copia qualsiasi formato. Anteprima dal vivo, funziona nel tuo browser.`)
};

const pt_br2_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de cores gratuito. Converta entre HEX, RGB e HSL, escolha uma cor e copie qualquer formato. Visualização ao vivo, funciona no seu navegador.`)
};

const pt_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de cores gratuito. Converta entre HEX, RGB e HSL, escolha uma cor e copie qualquer formato. Pré-visualização em direto, executa-se no seu navegador.`)
};

const ja_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の色変換ツール。HEX、RGB、HSLの間で変換し、色を選択し、任意の形式をコピーします。ライブプレビュー、ブラウザで実行されます。`)
};

const zh_cv_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费颜色转换器。在HEX、RGB和HSL之间转换，选取颜色，并复制任意格式。实时预览，运行于你的浏览器中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_tool_description", locale)
	if (locale === "en") return en_cv_tool_description(inputs)
	if (locale === "es") return es_cv_tool_description(inputs)
	if (locale === "de") return de_cv_tool_description(inputs)
	if (locale === "nl") return nl_cv_tool_description(inputs)
	if (locale === "fr") return fr_cv_tool_description(inputs)
	if (locale === "it") return it_cv_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_cv_tool_description(inputs)
	if (locale === "pt") return pt_cv_tool_description(inputs)
	if (locale === "ja") return ja_cv_tool_description(inputs)
	return zh_cv_tool_description(inputs)
};